var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSwapVertical = function SvgSwapVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 7.0013L8.00008 3.0013L4.00008 7.0013",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 3.0013V14.0013",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.9995L16 20.9995L20 16.9995",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.0005V10.0005",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "currentColor"
  })));
};
export default SvgSwapVertical;